import {
  Avatar,
  Box,
  createStyles,
  Flex,
  Group,
  Select,
  Text,
} from "@mantine/core";
import { IconShip, IconShoppingCart } from "@tabler/icons";
import { Discount2 } from "tabler-icons-react";
import UserStatus from "./userStatus";

const useStyles = createStyles((theme) => ({
  statBox: {
    display: "flex",
    backgroundColor: "#f8f9fa",
    padding: theme.spacing.md,
    borderRadius: theme.radius.sm,
    flex: "0 0 auto",
    maxWidth: "200px",
    margin: `${theme.spacing.xs}px 0`,
  },
  statTitle: {
    fontSize: theme.fontSizes.sm,
    fontWeight: 700,
    color: "#101F0C",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  statValue: {
    color: "#F36825",
    fontSize: theme.fontSizes.lg,
    fontWeight: 700,
    marginTop: 4,
  },
  timeSelect: {
    width: "150px",
    borderRadius: theme.radius.md,
    border: `1px solid ${theme.colors.gray[3]}`,
    backgroundColor: theme.white,
    "&:hover": {
      borderColor: theme.colors.blue[2],
    },
    "&:focus-within": {
      borderColor: theme.colors.blue[5],
      boxShadow: `${theme.shadows.sm} ${theme.colors.blue[5]}`,
    },
  },
  userStatusWrapper: {
    flex: 1,
    marginLeft: theme.spacing.md,
  },
}));

const icons = {
  user: IconShoppingCart,
  discount: Discount2,
  receipt: IconShoppingCart,
  coin: IconShip,
};
const dataDashboard = [
  {
    title: "Supplier commission",
    icon: "receipt",
    value: "",
    diff: 34,
  },
  {
    title: "SME commission",
    icon: "coin",
    value: "",
    diff: 0,
  },
  {
    title: "Driver commission",
    icon: "discount",
    value: "",
    diff: 18,
  },
];

export default function StatsGrid({
  data,
  loading,
  timeRange,
  onTimeRangeChange,
}) {
  const { classes } = useStyles();

  const fieldMap = {
    "Supplier commission": "total_commission_from_suppliers",
    "SME commission": "total_sme_commission",
    "Driver commission": "total_commission_from_drivers",
  };
  const formatNumber = (value) => {
    if (value === null || value === undefined) return "0";
    return new Intl.NumberFormat().format(value);
  };
  const stats = dataDashboard.map((stat) => {
    const value = data && fieldMap[stat.title] ? data[fieldMap[stat.title]] : 0;
    const Icon = icons[stat.icon];

    return (
      <Box className={classes.statBox} key={stat.title}>
        <Avatar radius="sm" size="md" color="blue" style={{ marginRight: 12 }}>
          <Icon size={24} />
        </Avatar>
        <div>
          <Text className={classes.statTitle}>{stat.title}</Text>
          <Text className={classes.statValue}>{formatNumber(value)}</Text>
        </div>
      </Box>
    );
  });

  return (
    <Flex
      gap="md"
      justify="space-between"
      align="center"
      style={{ marginTop: "16px" }}
    >
      <Group spacing="md" noWrap style={{ flex: 2, overflowX: "auto" }}>
        {stats}
      </Group>
      <Flex justify="space-between" align="center" mb="md">
        <UserStatus />
        <Select
          data={[
            { value: "DAILY", label: "Daily" },
            { value: "WEEKLY", label: "Weekly" },
            { value: "MONTHLY", label: "Monthly" },
            { value: "HALF_YEARLY", label: "Half Year" },
            { value: "YEARLY", label: "Yearly" },
          ]}
          value={timeRange}
          onChange={onTimeRangeChange}
          size="sm"
          placeholder="Select Range"
          className={classes.timeSelect}
        />
      </Flex>
    </Flex>
  );
}
